import { gql } from "@apollo/client"

export const getBudgetAvailability = gql`
  query getBudgetAvailability ($where: BudgetAvailabilityWhere!) {
    RegionBudgetAvailability( where: $where) {
      id
      year
      region
      modifiedAt
      operations
      cancellations
      initialAmount
      paidCollection
      projectedRevenue
      paidCollectionConcept
      specialprojects
    }
  }
`